import { G as useRecordVisibilityChanges, p as jsxRuntimeExports } from "./doenetml-NmXDuMHr.js";
import React__default, { useRef } from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-iiMuPv8N.js";
import { r as renderMarkupBody } from "./markupRenderer-BG6g6JTg.js";
const blockQuote = React__default.memo(function Container(props) {
  const { id, SVs, children, actions, callAction } = useDoenetRenderer(props);
  const ref = useRef(null);
  useRecordVisibilityChanges(ref, callAction, actions);
  const body = renderMarkupBody({ SVs, children });
  if (body === null) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "blockquote",
    {
      id,
      ref,
      style: SVs.renderInlineForListItem ? { marginTop: 0 } : void 0,
      children: body
    }
  );
});
export {
  blockQuote as default
};
